import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { combineLatest, map, of, switchMap } from 'rxjs';
import { firstMemo, memo } from "../util/index.js";

function extractsIds(stashId, queuedKeys, nextKeys) {
  var sessionIds = (queuedKeys.find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        currentId = _ref2[0];

    return currentId.eq(stashId);
  }) || [undefined, []])[1];
  var nextSessionIds = nextKeys.unwrapOr([]);
  return {
    nextSessionIds: Array.isArray(nextSessionIds) ? nextSessionIds : _toConsumableArray(nextSessionIds.values()),
    sessionIds: Array.isArray(sessionIds) ? sessionIds : _toConsumableArray(sessionIds.values())
  };
}

export var keys = firstMemo(function (api, stashId) {
  return api.derive.staking.keysMulti([stashId]);
});
export function keysMulti(instanceId, api) {
  return memo(instanceId, function (stashIds) {
    return stashIds.length ? api.query.session.queuedKeys().pipe(switchMap(function (queuedKeys) {
      var _api$consts$session;

      return combineLatest([of(queuedKeys), (_api$consts$session = api.consts.session) !== null && _api$consts$session !== void 0 && _api$consts$session.dedupKeyPrefix ? api.query.session.nextKeys.multi(stashIds.map(function (stashId) {
        return [api.consts.session.dedupKeyPrefix, stashId];
      })) : api.query.session.nextKeys.multi(stashIds)]);
    }), map(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2),
          queuedKeys = _ref4[0],
          nextKeys = _ref4[1];

      return stashIds.map(function (stashId, index) {
        return extractsIds(stashId, queuedKeys, nextKeys[index]);
      });
    })) : of([]);
  });
}